export default "__VITE_ASSET__Cnvqw34T__"